import { partialPercentage } from '../../utils/discountPercent';
import { moneyFormat } from '../../utils/moneyFormat';
import Container from './style';

interface Props {
  title: string;
  price_old: number;
  price_new: number;
  validate: string;
  productImage: string;
  onClick?: () => void;
}

const ProductCard = ({
  title,
  validate,
  price_old,
  price_new,
  productImage,
  ...rest
}: Props) => {
  return (
    <Container {...rest}>
      <div className="percent-discount">
        <p>{partialPercentage(price_old, price_new)}%</p>
      </div>
      <div className="image-container">
        <img src={productImage} />
      </div>

      <p className="title">{title}</p>

      <div>
        <p className="text-validate">{validate}</p>
        <p className="text-price-old">{moneyFormat(price_old)}</p>
        <p className="text-price-new">{moneyFormat(price_new)}</p>
      </div>
    </Container>
  );
};

export default ProductCard;
